module.exports = __webpack_public_path__ + "img/Copy.8d2c57fe.svg";